<template>
  <ul class="article-grid">
    <li
      v-for="(article, index) in articleDataset.articles"
      :key="index"
      class="col-xs-10 col-xs-push-1 col-sm-push-1 col-sm-5"
    >
      <article v-clickextension="'img,p'" class="article-item">
        <media-image
          class="article-item-image"
          :filename="article.image.filename"
          :resolutions="article.image.resolutions"
          :alt="article.image.alt"
          :sizes="article.image.sizes"
          :fallback-size="article.image['fallback-size']"
          :lazy="true"
          :ratio="article.image.ratio"
        ></media-image>
        <div class="article-item-info">
          <a v-tag="article.tagging_attributes" :href="article.url">
            <span class="article-title" v-html="article.title.replace(/&amp;#39;/g, '')"></span>
          </a>
          <p class="article-summary" v-html="article.summary.replace(/&amp;#39;/g, '')"></p>
          <p v-if="article.tags && article.tags.length" class="article-tags">
            <template v-for="(tag, index) in article.tags" :key="index"
              ><a :href="tag.url" class="article-tag">{{ tag.title }}</a
              ><span v-if="index < article.tags.length - 1" class="article-devider"
                >,
              </span></template
            >
          </p>
        </div>
      </article>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'grid',
  props: {
    articleDataset: { type: Object, required: true },
  },
};
</script>
